import styled, { css } from 'styled-components';
import { Wrapper } from 'AppReact';

const template = styled.div`
  ${({ theme, displayState }) => {
    return css`
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: ${displayState?.personSelector ? "110px": ""};
    gap: 18px;
  `}}
`;

export default Wrapper(template);
